var _defs, _path, _path2, _path3, _line, _line2, _line3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.3 41.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: .7px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-linecap: round;\r\n        stroke-width: .93px;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M21.87,27.11c-.09,4.05-3.44,7.25-7.49,7.16-3.92-.09-7.08-3.24-7.16-7.16,0-1.6.85-3.6,2.02-5.52,1.31-2.19,2.94-4.17,4.84-5.89.28-.23.68-.22.95,0,1.89,1.71,3.51,3.69,4.83,5.88,1.17,1.92,2.02,3.93,2.02,5.52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.03,21.57c-.1,4.29-3.66,7.69-7.95,7.59-4.15-.1-7.49-3.44-7.59-7.59,0-1.69.9-3.82,2.14-5.86,1.39-2.32,3.12-4.42,5.13-6.24.29-.24.72-.24,1.01,0,2,1.82,3.73,3.92,5.12,6.23,1.24,2.04,2.14,4.17,2.14,5.86"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.03,21.57c-.1,4.29-3.66,7.69-7.95,7.59-4.15-.1-7.49-3.44-7.59-7.59,0-1.69.9-3.82,2.14-5.86,1.39-2.32,3.12-4.42,5.13-6.24.29-.24.72-.24,1.01,0,2,1.82,3.73,3.92,5.12,6.23,1.24,2.04,2.14,4.17,2.14,5.86"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 23.78,
    y1: 21.43,
    x2: 28.74,
    y2: 21.43
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 26.29,
    y1: 18.6,
    x2: 26.26,
    y2: 24.26
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 12.07,
    y1: 27.09,
    x2: 17.02,
    y2: 27.09
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRh);
export default __webpack_public_path__ + "static/media/rh.f547c89fc0f0060f5f097b95d5cf1be7.svg";
export { ForwardRef as ReactComponent };